import { twMergeExt } from '@/shared/utils/twMergeExt';
import { cva } from 'class-variance-authority';
import { FC, useState } from 'react';

interface Props {
  className?: string;
  properties: Record<string, string>;
}

export const Properties: FC<Props> = ({ className, properties }) => {
  const [showAll, setShowAll] = useState(false);

  return (
    <div className={twMergeExt(cvaProperties(), className)}>
      {Object.entries(properties).map(([key, value], index) =>
        value && (index < 3 || showAll) ? (
          <dl key={index} className={cvaProperty()}>
            <dt
              className={cvaKey()}
              dangerouslySetInnerHTML={{
                __html: key
                  .split(' ')
                  .map((word) => `<span class='${cvaKeyWord()}'>${word}</span>`)
                  .join(' '),
              }}
            />

            <dd
              className={cvaValue()}
              dangerouslySetInnerHTML={{
                __html: value,
              }}
            />
          </dl>
        ) : null
      )}
      {!showAll && Object.entries(properties).length > 3 ? (
        <button
          onClick={() => setShowAll(true)}
          className="text-bodyMSemibold text-cBlack48 text-start border-b border-dashed w-fit"
        >
          Еще {Object.entries(properties).length - 3}
        </button>
      ) : null}
    </div>
  );
};

const cvaProperties = cva(['Properties-cvaProperties', 'flex flex-col gap-1.2', 'bg-inherit overflow-hidden']);

const cvaProperty = cva(['Properties-cvaProperty', 'relative', 'flex justify-between items-start', 'bg-inherit']);

const cvaKey = cva(['Properties-cvaKey', 'text-cBlack48 bg-inherit flex-nowrap flex gap-0.4']);

const cvaValue = cva([
  'Properties-cvaValue',
  'relative pl-0.4 text-cBlack bg-inherit max-w-[20rem] w-fit',
  'text-right',
]);

const cvaKeyWord = cva([
  'Properties-cvaKeyWord',
  'relative',
  'whitespace-nowrap',
  'last:pr-0.4',
  'last:before:absolute last:before:left-full last:before:w-screen last:before:bottom-0.4 last:before:h-0.1',
  'last:before:[background-image:linear-gradient(90deg,rgba(0,0,0,0.1)_50%,hsla(0,0%,100%,0)_0)] last:before:[background-size:0.4rem_0.1rem]',
]);
